import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@hyphengroup/cag-components';
import { HtmlParser } from 'components/common/';
import StaticUsPageContentPanel from './StaticPageContentPanel';
import PressPagePanel from '../Press/PressPagePanel';
import './StaticPageTemplate.scss';
import { getComponent } from './StaticPageUtils';

class StaticPageTemplate extends Component {
  constructor(props) {
    super(props);
    const { title } = this.props;
    this.state = {
      pressPageTitle: title,
    };
  }

  updatePageTitle = (newTitle) => {
    this.setState({
      pressPageTitle: newTitle,
    });
  };

  render() {
    const {
      title,
      content,
      children,
      richTextBlocks,
    } = this.props;
    const { pressPageTitle } = this.state;
    const htmlString = (richTextBlocks?.[0]?.text) || content?.html;
    return (
      <div className="static-page">
        <div className="static-page__container">
          <div className="static-page__header">
            <Typography as="h1" weight="light" sizeFont="px32" variant="secondary" lineHeightStyle="dp43" spacing="none">{pressPageTitle}</Typography>
          </div>
        </div>
        <div className="static-page__container">
          <div className="static-page__content">
            <div className="static-page__row">
              <main>
                <div className="static-page__inner-content">
                  {(() => {
                    switch (content?.type) {
                      case 'html':
                        return <HtmlParser display="block" htmlString={htmlString || ''} />;
                      case 'press':
                        return <PressPagePanel updateTitle={this.updatePageTitle} {...content} />;
                      default:
                        return null;
                    }
                  })()}
                </div>
              </main>
              <aside>
                <div className="static-page__panels">
                  <StaticUsPageContentPanel>
                    {getComponent('contactInfo', {
                      title,
                      content,
                      children,
                    })}
                  </StaticUsPageContentPanel>
                  <StaticUsPageContentPanel>
                    {getComponent('introduction', {
                      title,
                      content,
                      children,
                    })}
                  </StaticUsPageContentPanel>
                  {getComponent('socialMedia', {
                    title,
                    content,
                    children,
                  })}
                </div>
              </aside>
            </div>
          </div>
        </div>
        {getComponent('newsletter', {
          title,
          content,
          children,
        })}
      </div>
    );
  }
}

StaticPageTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.shape({
    html: PropTypes.string,
    type: PropTypes.string,
  }),
  children: PropTypes.node,
  richTextBlocks: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

StaticPageTemplate.defaultProps = {
  children: null,
  content: {},
};

export default StaticPageTemplate;
